export enum ScreeningDocType {
  Certificate = 'certificate',
  Qualification = 'qualification',
}

export enum CertificateStatus {
  Uploaded = 'uploaded',
  Approved = 'approved',
  Rejected = 'rejected',
}

export enum QualificationStatus {
  Uploaded = 'uploaded',
  MinimumMet = 'minimum_met',
  ExceptionGranted = 'exception_granted',
  Rejected = 'rejected',
}

export interface CertificateScreening {
  id: string;
  status: CertificateStatus;
  reason: string;
  reviewerId: string;
  uploadedAt: string;
  reviewedAt: string | null;
}

export interface QualificationScreening {
  id: string;
  status: QualificationStatus;
  reason: string;
  reviewerId: string;
  uploadedAt: string;
  reviewedAt: string | null;
}

export interface TutorScreening {
  certificate?: CertificateScreening;
  qualification?: QualificationScreening;
}

export interface ScreeningUploadFiles {
  certificate?: { file: string };
  qualification?: { file: string };
}
